(function() {
  'use strict';

  angular
    .module('mfTrainee.consts')
    .constant('sensionData', {
      ON_MOBILE: 'on-mobile',
      NO_FLASH: 'no-flash',
      NO_CAMERA: 'no-camera',
      NOT_IN_APP: 'not-in-app',
      ON_IPAD1: 'on-ipad1',
      UPGRADE_APP: 'upgrade-app'
    });

})();
